import { cx } from '@/utils/cx';
import { StarIcon } from '@/assets/icons';
import { formatCurrency, formatNumber } from '@/utils/format';
import type { StarProduct } from '@/types/product';
import styles from './StarCard.module.scss';

export interface StarCardProps {
  product: StarProduct;
  onSelect: (product: StarProduct) => void;
  /** `featured` renders a wider, fixed-width card for horizontal-scroll strips. */
  variant?: 'grid' | 'featured';
}

export function StarCard({ product, onSelect, variant = 'grid' }: StarCardProps) {
  return (
    <button
      type="button"
      className={cx(styles.card, variant === 'featured' && styles.featured)}
      onClick={() => onSelect(product)}
    >
      {product.badge === 'best-value' && <span className={styles.badge}>Best value</span>}
      <div className={styles.amountRow}>
        <StarIcon size={18} />
        <span className={styles.amount}>{formatNumber(product.amount)}</span>
      </div>
      <div className={styles.price}>{formatCurrency(product.price, product.currency)}</div>
    </button>
  );
}
